import { useTaskCreationContext } from '../../pages/TaskCreation';
import { OnboardingMessage } from './OnboardingMessage';
import { PayBillCreateForm } from './PayBillCreateForm';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Task } from '@admiin-com/ds-graphql';
import { useTaskCounts } from '../../features/hooks/useTaskCounts/useTaskCounts';
import { useDefaultValueForFromTo } from '../../features/providers/TaskCreationProvider/TaskCreationProvider';
import useTaskSearchFilters from '../../features/hooks/useTaskSearchFilters/useTaskSearchFilters';

export const PayBill = ({ onClose }: { onClose: () => void }) => {
  const { client } = useTaskCreationContext();
  const entity = useDefaultValueForFromTo();

  const { filters } = useTaskSearchFilters();
  const { counts } = useTaskCounts({
    entityId: entity?.id,
    ...filters,
  });
  const totalCount = counts?.ALL ?? 0;
  const { t } = useTranslation();

  const [isOnboarding, setIsOnboarding] = React.useState(true);

  React.useEffect(() => {
    if (totalCount === 0) {
      setIsOnboarding(true);
    } else setIsOnboarding(false);
  }, [totalCount]);

  const showOnboarding = isOnboarding && !(client ?? entity)?.termsOcrAccepted;

  const { task } = useTaskCreationContext();

  const [draftTask, setDraftTask] = React.useState<Task | null>(null);

  React.useEffect(() => {
    if (task) {
      setDraftTask(task);
    } else {
      setDraftTask(null);
    }
  }, [task]);

  return showOnboarding ? (
    <OnboardingMessage
      onGetStarted={() => setIsOnboarding(false)}
      title={t('payBillTitle', { ns: 'taskbox' })}
      description={[
        t('payBillMessage1', { ns: 'taskbox' }),
        t('payBillMessage2', { ns: 'taskbox' }),
        t('payBillMessage3', { ns: 'taskbox' }),
      ]}
      policy={t('payBillPolicyMessage', { ns: 'taskbox' })}
      buttonTitle={t('getStarted', { ns: 'taskbox' })}
    />
  ) : (
    <PayBillCreateForm draftTask={draftTask} onClose={onClose} />
  );
};
